(() => {
  const scripts = new Map();
  const instances = new WeakMap();
  let dependencies;

  const load = (url, ready) => {
    if (ready()) return Promise.resolve();
    if (scripts.has(url)) return scripts.get(url);
    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      const timer = setTimeout(() => { script.remove(); reject(new Error('Shipping dependency timeout')); }, 15000);
      script.onload = () => { clearTimeout(timer); ready() ? resolve() : reject(new Error('Shipping dependency unavailable')); };
      script.onerror = () => { clearTimeout(timer); script.remove(); reject(new Error('Shipping dependency failed')); };
      document.head.appendChild(script);
    });
    scripts.set(url, promise);
    promise.catch(() => scripts.delete(url));
    return promise;
  };

  const ensureDependencies = root => {
    if (!dependencies) {
      dependencies = (async () => {
        if (!window.jQuery) throw new Error('Shipping requires jQuery');
        window.Shopify = window.Shopify || {};
        await load('/services/javascripts/countries.js', () => typeof window.Countries === 'object');
        await load(root.dataset.commonUrl, () => typeof Shopify.CountryProvinceSelector === 'function');
        await load('https://ajax.aspnetcdn.com/ajax/jquery.templates/beta1/jquery.tmpl.min.js', () => typeof jQuery.fn.tmpl === 'function');
        await load(root.dataset.cartUrl, () => typeof Shopify.Cart?.ShippingCalculator?.show === 'function');
      })();
      dependencies.catch(() => { dependencies = null; });
    }
    return dependencies;
  };

  const mount = root => {
    if (!root.isConnected || instances.get(root) === 'loading' || instances.get(root) === 'ready') return;
    const button = root.querySelector('.get-rates');
    if (!button) return;
    instances.set(root, 'loading');
    button.disabled = true;
    root.setAttribute('aria-busy', 'true');
    ensureDependencies(root).then(() => {
      if (!root.isConnected || document.getElementById('shipping-calculator') !== root) return;
      Shopify.Cart.ShippingCalculator.show({
        submitButton: root.dataset.submitLabel,
        submitButtonDisabled: root.dataset.busyLabel,
        customerIsLoggedIn: root.dataset.customer === 'true',
        moneyFormat: root.dataset.moneyFormat
      });
      instances.set(root, 'ready');
      root.removeAttribute('aria-busy');
    }).catch(() => {
      if (!root.isConnected) return;
      instances.set(root, 'error');
      root.removeAttribute('aria-busy');
      button.disabled = false;
      const feedback = root.querySelector('#wrapper-response');
      if (feedback) {
        feedback.textContent = 'Shipping estimate could not load. Select Calculate shipping to retry.';
        feedback.setAttribute('role', 'status');
        feedback.style.display = 'block';
      }
    });
  };

  document.addEventListener('click', event => {
    const button = event.target.closest?.('#shipping-calculator .get-rates');
    const root = button?.closest('#shipping-calculator');
    if (root && instances.get(root) !== 'ready') {
      event.preventDefault();
      event.stopImmediatePropagation();
      mount(root);
    }
  }, true);

  const scan = () => document.querySelectorAll('#shipping-calculator').forEach(mount);
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.id === 'shipping-calculator' || node.querySelector('#shipping-calculator'))))) scan();
  }).observe(document.body, {subtree: true, childList: true});
  scan();
})();
